import Icon from "@mdi/react";
import { mdiCalendarCheckOutline, mdiCalendarQuestion, mdiVoteOutline } from "@mdi/js";
import { Box, CardContent, ToggleButton, Typography } from "@mui/material";
import CardWithAvatar from "components/CardWithAvatar";

import { VoteByEventId, VoteType } from "api/vote";
import { EventCountdownType } from "../EventCountdown/EventCountdown";
import { VEHICLES } from "../VehicleSelectionDialog/VehicleSelectionDialog";

export interface EventVoteButtonsProps {
  countdownType: EventCountdownType;
  onVote: () => Promise<void>;
  onVehicleClick: () => void;
  userVote?: VoteByEventId;
}

function EventVoteButtons(props: EventVoteButtonsProps) {
  const { countdownType, onVote, onVehicleClick, userVote } = props;
  const participating = userVote?.type === VoteType.PARTICIPATING;
  const vehicle = userVote?.vehicle_details;
  const withVehicle = Boolean(vehicle);
  const canVote = countdownType === "vote";

  const JoinButton = (
    <ToggleButton color='primary' onClick={onVote} selected={participating} value='participation-vote'>
      <Icon
        path={participating ? mdiCalendarCheckOutline : mdiCalendarQuestion}
        size={1}
        title={participating ? "calendar-checked" : "calendar-question"}
      />
      <Box ml={1}>{participating ? "Joined event" : "Join event"}</Box>
    </ToggleButton>
  );

  const VehicleButton = (
    <ToggleButton
      sx={{ marginLeft: 1 }}
      aria-label={getVehicleButtonLabel()}
      color='primary'
      onChange={onVehicleClick}
      selected={withVehicle}
      value='vehicle'
    >
      <Icon path={withVehicle ? VEHICLES[vehicle!.type].icon : VEHICLES["mid-size-car"].icon} size={1} />
      {!canVote ? <Box ml={1}>{withVehicle ? "With vehicle" : "Bring vehicle"}</Box> : null}
    </ToggleButton>
  );

  const Placeholder = (
    <Typography color='text.secondary' textAlign='center'>
      {participating ? null : "The event has started and joining is no longer possible"}
    </Typography>
  );

  function getVehicleButtonLabel() {
    if (canVote) {
      return withVehicle ? "With vehicle" : "Bring vehicle";
    }

    return undefined;
  }

  return (
    <CardWithAvatar
      icon={<Icon path={mdiVoteOutline} size={1.2} />}
      subheader={participating ? "Participant" : "Pending"}
      title='Status'
    >
      <CardContent sx={{ display: "flex", justifyContent: "center" }}>
        {canVote ? JoinButton : null}
        {participating ? VehicleButton : null}
        {!canVote && Placeholder}
      </CardContent>
    </CardWithAvatar>
  );
}

export default EventVoteButtons;
